var render = function render(){var _vm=this,_c=_vm._self._c;return _c('span',{staticClass:"save-status",class:{ 'save-status--dirty': _vm.dirty }},[(_vm.dirty)?_c('span',{staticClass:"save-status__dot"}):_vm._e(),(_vm.dirty)?_c('span',[_vm._v("Unsaved changes")]):(_vm.saved)?_c('span',[_vm._v("All changes saved")]):_c('span',[_vm._v("Not saved yet")])])
}
var staticRenderFns = []

export { render, staticRenderFns }